import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-whatsapp-float',
  imports: [NgClass],
  templateUrl: './whatsapp-float.html',
  styleUrl: './whatsapp-float.css',
})
export class WhatsappFloat {
  @Input() phoneNumber: string = '923369949494';
  @Input() message: string = 'Hello! I have a question about your services.';
  @Input() showLabel: boolean = true;
  @Input() labelText: string = 'Need Help? Chat on WhatsApp';
  @Input() position: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' = 'bottom-right';
  @Input() showOnlyInHours: boolean = false;
  @Input() businessHours: { start: number, end: number } = { start: 9, end: 18 };
  @Input() timezone: string = 'IST';
  @Input() enablePulse: boolean = true;

  whatsappUrl: string = '';
  isVisible: boolean = true;
  isMobile: boolean = false;

  ngOnInit() {
    this.checkIfMobile();
    this.generateWhatsAppUrl();
    this.checkBusinessHours();
  }

  private checkIfMobile(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  private generateWhatsAppUrl(): void {
    // Remove any non-digit characters from phone number
    const cleanNumber = this.phoneNumber.replace(/\D/g, '');
    const encodedMessage = encodeURIComponent(this.message);
    this.whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
  }

  private checkBusinessHours(): void {
    if (!this.showOnlyInHours) return;
    
    const now = new Date();
    const currentHour = now.getHours();
    this.isVisible = currentHour >= this.businessHours.start && currentHour < this.businessHours.end;
  }

 
  // Optional: Update on window resize
  onResize(event: any): void {
    this.isMobile = event.target.innerWidth <= 768;
  }

closeLabel() {
  this.showLabel = false;
}
}
